import { render, staticRenderFns } from "./PlatDownload.vue?vue&type=template&id=70bec330&"
import script from "./PlatDownload.vue?vue&type=script&lang=js&"
export * from "./PlatDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports